import React from 'react';
import Icon from 'components/AppIcon';

const TimeEntrySummary = ({ totalHoursToday, totalBillableToday, draftCount, totalEntries }) => {
  const formatHours = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h === 0) return `${m}m`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}m`;
  };

  const cards = [
    {
      label: "Today\'s Hours",
      value: formatHours(totalHoursToday),
      icon: 'Clock',
      color: 'bg-primary-50 text-primary',
      iconBg: 'bg-primary-100'
    },
    {
      label: "Today\'s Billable",
      value: `KES ${Number(totalBillableToday)?.toLocaleString('en-KE', { minimumFractionDigits: 0 })}`,
      icon: 'TrendingUp',
      color: 'bg-success-50 text-success-700',
      iconBg: 'bg-success-100'
    },
    {
      label: 'Draft Entries',
      value: draftCount,
      icon: 'FileEdit',
      color: 'bg-warning-50 text-warning-700',
      iconBg: 'bg-warning-100'
    },
    {
      label: 'Total Entries',
      value: totalEntries,
      icon: 'List',
      color: 'bg-secondary-50 text-secondary-700',
      iconBg: 'bg-secondary-100'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards?.map((card, i) => (
        <div key={i} className="bg-surface rounded-xl border border-border p-4">
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm text-text-secondary">{card?.label}</span>
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${card?.iconBg}`}>
              <Icon name={card?.icon} size={16} className={card?.color?.split(' ')?.[1]} />
            </div>
          </div>
          <p className={`text-xl font-heading-semibold ${card?.color?.split(' ')?.[1]}`}>{card?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default TimeEntrySummary;
